import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceByMaterialsCategories(companyId, query) {
  return dataTransferWrap(
    ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES,dtConfig[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES].getReportsFinanceByMaterialsCategories,
    {
      urlParams: {
        companyId: companyId,
      },
      params: query,
    },
  )
}

export default {
  getReportsFinanceByMaterialsCategories
}